import { useLocation, useNavigate } from 'react-router-dom';
import { safeReturnTo } from 'utils/authReturn';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
export default function AuthGuard({ children }: GuardProps) {
  const { isLoggedIn, userNotFound } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      const returnTo = safeReturnTo(location.pathname + location.search + location.hash);
      navigate('/login' + (returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ''), { replace: true });
      return;
    }

    // Auth0 session is valid but there's no matching Weightrax user record for this identity.
    if (userNotFound) {
      navigate('/pages/access-denied', { replace: true });
    }
  }, [isLoggedIn, userNotFound, navigate, location.pathname, location.search, location.hash]);

  // Nothing behind this guard can load for an unknown user, and its 401s would bounce to /login.
  if (userNotFound) return null;

  return children;
}
